var render = function render(){var _vm=this,_c=_vm._self._c;return _c('legal-page',{attrs:{"content":_vm.content}})
}
var staticRenderFns = []

export { render, staticRenderFns }